import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const TestimonialContainer = styled.div`
  padding: 100px 0;
  background: #1A365D;
  color: #fff;
`;

const TestimonialWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 50px;
  
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;

const TestimonialTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 60px;
  font-family: 'Playfair Display', serif;
  color: #fff;
  
  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const TestimonialCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
`;

const TestimonialCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 30px;
  max-width: 350px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  
  &:before {
    content: '"';
    font-size: 80px;
    font-family: 'Playfair Display', serif;
    position: absolute;
    top: -20px;
    left: 20px;
    color: rgba(255, 255, 255, 0.1);
  }
`;

const TestimonialText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  font-style: italic;
  font-family: 'Open Sans', sans-serif;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #4CAF50;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 20px;
  color: #fff;
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.h4`
  font-size: 18px;
  margin-bottom: 5px;
  font-family: 'Playfair Display', serif;
`;

const AuthorRelation = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Open Sans', sans-serif;
`;

const Testimonials = () => {
  return (
    <TestimonialContainer id="testimonials">
      <TestimonialWrapper>
        <TestimonialTitle>O que dizem sobre nós</TestimonialTitle>
        <TestimonialCards>
          <TestimonialCard
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <TestimonialText>
              "Em um momento tão difícil, fomos tratados com muito respeito e profissionalismo. A estrutura é excelente e o serviço de Velório Online permitiu que familiares distantes pudessem participar da cerimônia."
            </TestimonialText>
            <TestimonialAuthor>
              <AuthorImage>M</AuthorImage>
              <AuthorInfo>
                <AuthorName>Maria Silva</AuthorName>
                <AuthorRelation>Cliente</AuthorRelation>
              </AuthorInfo>
            </TestimonialAuthor>
          </TestimonialCard>
          
          <TestimonialCard
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <TestimonialText>
              "A cerimônia personalizada foi um momento de conforto para toda a família. O ambiente é acolhedor e a equipe muito atenciosa. Agradeço por todo o suporte nesse momento difícil."
            </TestimonialText>
            <TestimonialAuthor>
              <AuthorImage>J</AuthorImage>
              <AuthorInfo>
                <AuthorName>João Santos</AuthorName>
                <AuthorRelation>Cliente</AuthorRelation>
              </AuthorInfo>
            </TestimonialAuthor>
          </TestimonialCard>
          
          <TestimonialCard
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <TestimonialText>
              "O plano familiar que adquirimos nos trouxe tranquilidade em um momento tão delicado. Toda a documentação foi providenciada com agilidade e o atendimento foi excepcional."
            </TestimonialText>
            <TestimonialAuthor>
              <AuthorImage>A</AuthorImage>
              <AuthorInfo>
                <AuthorName>Ana Oliveira</AuthorName>
                <AuthorRelation>Cliente</AuthorRelation>
              </AuthorInfo>
            </TestimonialAuthor>
          </TestimonialCard>
        </TestimonialCards>
      </TestimonialWrapper>
    </TestimonialContainer>
  );
};

export default Testimonials;
